import React from "react";
import PropTypes from "prop-types";
import moment from "moment";
import "./styles/Time.css";

/**
* @param Date Object
* @returns Time formatted e.g "01:24", "03:48" OR "a day ago, at 01:24", "2 days ago, at 02:24" if more than 24 hous ago  
*/

const Time = ({ d }) => {
  let time, clock;

  function prependZero(num) {
    return num < 10 ? `0${num}` : num;
  }
  function isMoreThanADay(dateBefore) {
    const timeDiff = new Date().getTime() - dateBefore.getTime();
    const timeDiffHrs = timeDiff / (1000 * 60 * 60);
    return timeDiffHrs > 24;
  }

  if (d) {
    clock = `${prependZero(new Date(d).getHours())} : ${prependZero(
      new Date(d).getMinutes()
    )}`;
    isMoreThanADay(new Date(d))
      ? (time = `${moment(d).fromNow()}, at ${clock}`)
      : (time = clock);
  } else {
    time = "--:--";
  }

  return <span className="Time">{time}</span>;
};

Time.propTypes = {
  d: PropTypes.string.isRequired
};

export default Time;



// WEBPACK FOOTER //
// ./src/modules/Time.js